import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=348a3e8b&"
import script from "./ProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports